import axios from 'axios';
import { LIBRARY_ADMIN_ROLE, SUPER_ADMIN_ROLE} from "./utlis/constant";
import i18n from "./config/i18n";

const baseURL = window?.appConfig?.REACT_APP_API_GATEWAY || process.env.REACT_APP_API_GATEWAY;
const baseURLBatch = window?.appConfig?.REACT_APP_API_ORCHESTRATOR || process.env.REACT_APP_API_ORCHESTRATOR;
const baseURIV1Batch = window?.appConfig?.REACT_APP_URI_V1_ORCHESTRATOR || process.env.REACT_APP_URI_V1_ORCHESTRATOR;
const baseURIV2Batch = window?.appConfig?.REACT_APP_URI_V2_ORCHESTRATOR || process.env.REACT_APP_URI_V2_ORCHESTRATOR;

const currentLang = i18n.language;

const axiosClient = axios.create({
    baseURL: `${baseURL}/api/`,
});

const axiosClientBatch = axios.create({
    baseURL: `${baseURLBatch}${baseURIV1Batch}`,
});

const axiosClientBatchV2 = axios.create({
    baseURL: `${baseURLBatch}${baseURIV2Batch}`,
});

export const login = (email, password, role) => {
    return axiosClient.post('login', { email, password, role });
};


export const logout = () => {

    return axiosClient.post('logout');
};

export const acceptEula = () => {

    return axiosClient.post('/accept-eula');
};
export const register = (formData) => {
    const { name, email, password, departments, isFreeAgent } = formData;

        return axiosClient.post('register', {
            name,
            email,
            password,
            departments: departments,
            isFreeAgent: isFreeAgent,
            language: currentLang
});
};
export const addLibrarian = async (formData) => {
    const { name, email, password, department, address, phone } = formData;

    return axiosClient.post('add_librarian', {
        name,
        email,
        password,
        department_id: department,
        address,
        phone
    });
};
export const addLibrarianAdmin = async (formData) => {
    const { name, email, password, university, address, phone } = formData;

    return axiosClient.post('add_library-admin', {
        name,
        email,
        password,
        university_id: university,
        address,
        phone
    });
};

const getToken = () => localStorage.getItem('token');

axiosClient.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response) {

            if (error.response.status === 401 && error.config.url != "login") {

                localStorage.removeItem('token');
                window.location.href = `/${currentLang}/authentication/sign-in`;
            } else if (error.response.status === 403) {

                window.location.href = `/${currentLang}/dashboard`;
            } else if (error.response.status === 404) {

                window.location.href = "/error-page";
            }
        } else {
            console.error('An error occurred:');
        }
        return Promise.reject(error);
    }
);

export const getDigitizationCount = () => {
    return  axiosClient.get(`digitization-count`)
};

export const getResearchersActivity = (params) => {
    return axiosClient.get('researchers-activity', { params });
};

export const activateUsers = (ids, data) => {
    return  axiosClient.put(`activate-users/${ids}`, data)
};

export const activateLibraryAdmins = (ids, data) => {
    return  axiosClient.put(`activate-library-admins/${ids}`, data)
};


export const activateUserByRole = (role, ids, data) => {

    if (role === LIBRARY_ADMIN_ROLE) {
        return activateLibraryAdmins(ids, data);
    } else {
        return activateUsers(ids, data);
    }
}

export const getResearchersList = (params) => {
    return axiosClient.get('researchers' + params );
};

export const getUsersList = (params) => {
    return axiosClient.get('users', { params });
};



export const getDepartementsList = (params = null) => {

    return axiosClient.get('departments' + (params ?? "") );
};
export const getLibrarianAdminsList = (params) => {
    return axiosClient.get('library-admins' + params );
};
export const getAnonymousUsersList = (params) => {
    return axiosClient.get('anonymous-users' + params );
};
export const getLibrariansList = (params) => {
    return axiosClient.get('librarians' + params );
};

export const getProfile = (role) => {

    if (role === SUPER_ADMIN_ROLE || role === LIBRARY_ADMIN_ROLE) {

        return axiosClient.get('admin-profile');
    } else {

        return axiosClient.get('user-profile');
    }
};
export const updateProfile = (id, updatedData, role) => {

    if (role === SUPER_ADMIN_ROLE || role === LIBRARY_ADMIN_ROLE) {

        return axiosClient.put(`/admins/${id}`, updatedData);
    } else {
        return axiosClient.put(`/users/${id}`, updatedData);
    }
};
export const updateFreeAgentProfile = (id, updatedData) => {
        return axiosClient.put(`/users/${id}`, updatedData);
};
export const getUniversities = (params = '') => {
  return axiosClient.get(`universities${params}`)
};

export const getPublicUniversities = () => {

    return axiosClient.get('public/universities')
};
export const AddUniversities = (data) => {
    return axiosClient.post('universities', data)
};

export const EditUniversities = (id, updatedData) => {
    return axiosClient.put(`/universities/${id}`, updatedData)
};
export const DeleteUniversity = (id) => {
    return axiosClient.delete(`/universities/${id}`)
};


export const addDepartment = (data) => {
    return axiosClient.post('departments', data)
};
export const updateDepartment = (id, updatedData) => {
    return axiosClient.put(`/departments/${id}`, updatedData);
};
export const getDigitizations = (params) => {

    return axiosClient.get('digitizations' + params);
};


export const getUserDocuments = (params) => {

    return axiosClient.get('my-documents' + params);
};

export const getDigitizationResult = (id) => {
    return axiosClient.get(`/digitization-result/${id}`)
}

export const getArchivesByPeriod = (params) => {

    return axiosClient.get('digitizations-by-period' + params);
};

export const getDigitizationsReport = (params = '') => {
    return axiosClient.get(`digitizations-statistics-by-period${params}`);
};

export const exportDigitizationsReport = (params = '') => {
    return axiosClient.get(`digitizations-statistics-export${params}`);
};

export const getArchivesById = (id) => {
    return axiosClient.get(`digitizations/${id}`);
};
export const scheduleDownload = (id, title, selectedOptions) => {
    return axiosClient.post(`schedule_download/${id}`, {title: title, selectedOptions: selectedOptions});
};
export const getExportedDocuments = (data) => {
    return axiosClient.post(`get-exported-documents`, data);
};
export const downloadFile = (data) => {
    return axiosClient.post(`download_file`, data, { responseType: 'blob' });
};

export const deleteFile = (title) => {
    return axiosClient.post(`delete_file`, {title: title});
};

export const getArchivesResultById = (id, numPage) => {
    return axiosClient.get(`digitizations-result/${id}/pages/${numPage}`);
};

export const getSubjects = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`subjects${queryString}`);
};

export const getServices = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`digitizations/services${queryString}`);
};
export const getAllServices = (params = '') => {
    return axiosClient.get(`services${params}`)
};

export const updateService = (serviceId, updatedFields) => {
    return axiosClient.patch(`services/${serviceId}`, updatedFields);
};

export const getOutputFormat = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`/output-formats${queryString}`);
};

export const getNonExecutedServices = (id, lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`/digitizations/${id}/non-executed-services${queryString}`)
};

export const runSelectedServices = (id, data) => {
    return axiosClient.post(`/digitizations/${id}/services`, data)
};

export const addSubject = (data) => {
    return axiosClient.post('subjects', data)
};

export const digitize = (data) => {
    return axiosClient.post('digitizations', data)
};

export const rerunService = (digitization_id,data) => {
    return axiosClient.post(`rerun-digitizer/${digitization_id}`, data)
};

export const skipService = (digitization_id, data) => {
    return axiosClient.post(`digitization/${digitization_id}/skip-service`, data)
};
export const createArticle = (data) => {
    return axiosClient.post('articles', data)
};

export const deleteArticle = (article_id) => {
    return axiosClient.delete(`/digitizations/${article_id}`);
};


export const forgotPassword = (email) => {
    return axiosClient.post('password-reset-request', { email, language: currentLang });
    
};



export const UpdatePassword = (token, new_password, confirm_password) => {
    return axiosClient.post('password-reset-confirm', { 
      token, 
      new_password, 
      confirm_password 
})};

export const getStatistics = () => {
    return axiosClient.get('statistics');
};
export const checkDuplicatedArticles = (params) => {
    return axiosClient.get('check-duplicated-articles', params);
};

export const getDepartmentsByUniversity = (university_id) => {
    return axiosClient.get(`public/departments?university_id=${university_id}`);
};

export const getOrdersReport = () => {
    return axiosClient.get('orders-report');
};

export const getOcrModes = (lang = 'en', params = '') => {
    const queryString = params || `?lang=${lang}`;
    return axiosClient.get(`/digitizations/ocr-modes${queryString}`);
};

export const createOrder = (articleIds, paymentSource) => {
    return axiosClient.post(`/create-order`, {article_ids: articleIds, payment_source: paymentSource});
};

export const captureOrder = (orderId) => {
    return axiosClient.post(`/capture-order/${orderId}`);
};

export const rerunDigitizer = (digitizationId) => {
    return axiosClient.post(`/rerun-digitizer/${digitizationId}`, {});
};
export const diacritizeDraft = (words) => {
    return axiosClient.post(`/diacrtics-drafter`, {words: words});
}

export const removeDiacritics = (params) => {
  return axiosClient.post(`/remove-diacrtics`, {params});
}

export const removeDiacriticsFromWords = (params) => {
    return axiosClient.post(`/remove-diacrtics-from-words`, {params});
}

export const refundPayment = (orderId, refundAmount, description) => {
    return axiosClient.post(`/refund_payment/${orderId}`, {refund_amount: refundAmount, description: description});
};

export const deleteLibrarianAdmin = (id) => {
    return axiosClient.delete(`/librarian-admins/${id}`);
};

export const updatePagesDataByArticleId = (article_id, data) => {
    return axiosClient.put(`/article/${article_id}/update-pages`, data);
};

export const updateMetadata = (id, updatedMetadata) => {
    return axiosClient.patch(`/digitizations/${id}`, updatedMetadata);
};

export const downloadAudio = (articleId, title) => {
    return axiosClient.post(`/article/${articleId}/download-audio`, {title: title});
};

export const regenerateSelectedServices = (payload) => {
    return axiosClient.post(`/regenerate-service-results`, payload);
};

export const getServicesToRegenerate = (digitizationId) => {
    return axiosClient.get(`/get-services-to-regenerate/${digitizationId}`);
};

export const loadBatches = () => axiosClientBatchV2.post(`/batch-ingestion`);

export const fetchBatches = (page = 1, pageSize = 6) =>
    axiosClientBatch.get(`/batches?page=${page}&page_size=${pageSize}`);

export const startBatch = (batchId, ocrType) => axiosClientBatch.post(`/start/${batchId}`, null, { params: {ocr_type: ocrType}});
export const stopBatch = (batchId) => axiosClientBatch.post(`/stop/${batchId}`);
export const startDeliveryBatch = (batchId) => axiosClientBatch.post(`/start-delivery/${batchId}`);
export const uploadMissingFiles = (batchId) => axiosClientBatchV2.post(`/upload-missing-files/${batchId}`);
export const stopDeliveryBatch = (batchId) => axiosClientBatch.post(`/stop-delivery/${batchId}`);
export const startBatchQualityCheck = (batchId) => axiosClientBatch.post(`/start-quality-check/${batchId}`);
export const stopBatchQualityCheck = (batchId) => axiosClientBatch.post(`/stop-quality-check/${batchId}`);


export const acceptBatch = (batchId) => axiosClientBatch.post(`/batches/${batchId}/accept`);
export const archiveBatch = (batchId) => axiosClientBatch.delete(`/batches/${batchId}`);

export const fetchFilesByBatch = (batchId, page = 1, pageSize = 10, name = undefined, status = undefined, notes = undefined, tablesFilter = undefined, qualityFilter = undefined) => {
    const params = {
        batch_id: batchId,
        page: page,
        page_size: pageSize
    }
    if (name) params.name = name;
    if (notes) params.notes = notes;
    if (status) params.status = status;
    if (tablesFilter) {
        params.tables_percentage_range_min = tablesFilter[0];
        params.tables_percentage_range_max = tablesFilter[1];
    }
    if (qualityFilter && qualityFilter !== "all") {
        params.quality_filter = qualityFilter;
    }
    return axiosClientBatch.get('/files', { params });
};

export const getBatchFilesStatus = (batchId) => {

    return axiosClientBatch.get(`/batch-files-statuses/${batchId}`);
}

export const deliverFileById = (fileId) =>
    axiosClientBatch.post(`/files/${fileId}/deliver`);

export const digitizeFileById = (fileId, ocrType) =>
    axiosClientBatch.post(`/files/${fileId}/digitize`, null, { params: {ocr_type: ocrType}});

export const updateFileStatus = (fileIds, status) => {
    return axiosClientBatch.post("/files/update-status", { status, file_ids: fileIds });
}

export const rerunDigitization = (fileId) => {
    return axiosClientBatchV2.post(`/files/${fileId}/pages/rerun-digitization`);
}

export const getGlobalMetrics = () =>
    axiosClientBatch.get(`/global_metrics`);

export const updateFileNotes = (fileId, notes) => {
    return axiosClientBatch.patch(`/files/${fileId}/notes`, { notes });
};

export const regenerateDigitizationZip = (digitizationId) => {
    return axiosClient.post('/digitization/regenerate-zip-html-xml', {
        digitization_id: digitizationId
    });
};

export const uploadToGoogleStorage = (file) => {
    const formData = new FormData();
    formData.append("file", file);

    return axiosClient.post("/upload-file", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const updateBatchAutoRestart = (batchId, autoRestart) =>
    axiosClientBatch.patch(`/batches/${batchId}/auto-restart`, {
        auto_restart: autoRestart,
});

export const runQualityCheck = (fileId) => {
    return axiosClientBatch.post(`/files/${fileId}/quality-check`);
};

export const updateChunkContent = (chunkId, content) => {
    return axiosClient.patch(
        `/digitization/chunks/${chunkId}`,
        { content: content }
    );
 };
